// extracted by mini-css-extract-plugin
export default {"spinner-content":"IpaAdministrationWizard_spinner-content__cXR51","spinner":"IpaAdministrationWizard_spinner__ctSD2"};